(function() {
  var SMALL_SCREEN_MAX_WIDTH = 600;

  var searchFormComponent;
  var mobileSearchFormComponent
  var searchForm = document.forms['searchForm'];
  var mobileSearchForm = document.forms['mobileSearchForm']

  function isSmallScreen() {
    return document.documentElement.clientWidth < SMALL_SCREEN_MAX_WIDTH;
  }

  function toggleSearchForms() {
    if(isSmallScreen()) {
      // init mobile search form component only once
      if(!mobileSearchFormComponent) {
        mobileSearchFormComponent = $campanda.SearchForm({
          TARGET_ELEMENT: mobileSearchForm
        });
      }
    } else {
      // init search form component only once
      if(!searchFormComponent) {
        searchFormComponent = $campanda.SearchForm({
          TARGET_ELEMENT: searchForm
        });
      }
    }
  }

  $campanda.Overlay.init();
  $campanda.Tabs.init();

  toggleSearchForms();
  window.addEventListener('resize', toggleSearchForms);
}());
